"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const NewRelic = ({ adId, esiType }) => {
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        try {
            if (adId) {
                (_b = (_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.setCustomAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, "onlineAdvertsBannerAdId", adId);
            }
            if (esiType) {
                (_d = (_c = window === null || window === void 0 ? void 0 : window.newrelic) === null || _c === void 0 ? void 0 : _c.setCustomAttribute) === null || _d === void 0 ? void 0 : _d.call(_c, "onlineAdvertsBannerType", esiType);
            }
        }
        catch (exception) {
            console.error(exception);
        }
    }, [adId, esiType]);
    return null;
};
exports.default = NewRelic;
